import numeral from 'numeral';

export class NumberValueConverter {
  toView(value, format) {
    if (!value) return null;
    if (!format) format = '0,0'
    let formatted = numeral(value).format(format)
    return formatted;
  }

  fromView(value, format) {
    if (value == 0)
      return value;
    return numeral(value).format(format);
  }
}
